import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route, useLocation } from "react-router-dom";
// import BackToTopButton from "./components/common/BackToTopButton";
import Footer from "./components/common/Footer";
import Loader from "./components/common/Loader";
import Navbar from "./components/common/Navbar";
// import NewsLetter from "./components/common/NewsLetter";

import { closeDropdown, closeNotifications } from "./features/uiSlice";

import {
  BookingSuccess,
  CarDetails,
  ConfirmBooking,
  Home,
  PageNotFound,
  BookNow,
  PaymentPolicy,
  TermsAndConditions,
  AddExtras,
} from "./pages";

import BookingFailure from "./pages/BookingFailure";

import SpeedBoat from "./pages/SpeedBoat";
import SpeedBoatRentals from "./pages/SpeedBoatRentals";
import LuxuryYacht from "./pages/LuxuryYacht";

import PacketDetails from "./pages/PacketDetails";

import Layout from "./components/common/Layout";
import Contact from "./pages/Contact";
import About from "./pages/About";

import UniqueTours from "./pages/UniqueTours";
import NewBooking from "./pages/NewBooking";
import AdminCalendar from "./pages/AdminCalendar";
import Partner from "./pages/Partner";

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
      window.gtag("config", "G-1N3FZNH5BB", {
        page_path: location.pathname,
      });
    }, [location]);
  }
  usePageTracking();

  const handleCloseDropdown = () => {
    dispatch(closeDropdown());
    dispatch(closeNotifications());
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const handleLoad = () => setShowLoader(false);
    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <div>
      {showLoader && <Loader />}
      <Navbar />
      <div className="min-h-screen" onClick={handleCloseDropdown}>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route
            path="/boat-tours"
            element={
              <Layout>
                <SpeedBoat />
              </Layout>
            }
          />
          <Route
            path="/jet-ski"
            element={
              <Layout>
                <SpeedBoatRentals />
              </Layout>
            }
          />

          <Route
            path="/unique-tours"
            element={
              <Layout>
                <UniqueTours />
              </Layout>
            }
          />

          <Route
            path="/luxury-yacht"
            element={
              <Layout>
                <LuxuryYacht />
              </Layout>
            }
          />

          <Route
            path="/contact"
            element={
              <Layout>
                <Contact />
              </Layout>
            }
          />
          <Route
            path="/about"
            element={
              <Layout>
                <About />
              </Layout>
            }
          />
          <Route
            path="/book-now"
            element={
              <Layout>
                <BookNow />
              </Layout>
            }
          />
          <Route
            path="/payment-policy"
            element={
              <Layout>
                <PaymentPolicy />
              </Layout>
            }
          />
          <Route
            path="/terms-and-conditions"
            element={
              <Layout>
                <TermsAndConditions />
              </Layout>
            }
          />
          <Route
            path="/add-extras"
            element={
              <Layout>
                <AddExtras />
              </Layout>
            }
          />

          <Route
            path="/:type/:id/confirm-booking"
            element={
              <Layout>
                <ConfirmBooking />
              </Layout>
            }
          />
          <Route
            path="/:slug/tour-details"
            element={
              <Layout>
                <NewBooking />
              </Layout>
            }
          />
          <Route
            path="/:slug/book-now"
            element={
              <Layout>
                <BookNow />
              </Layout>
            }
          />
          <Route
            path="/packet/:id/booking-sucess"
            element={
              <Layout>
                <BookingSuccess />
              </Layout>
            }
          />
          <Route
            path="/booking-success"
            element={
              <Layout>
                <BookingSuccess />
              </Layout>
            }
          />
          <Route
            path="/booking-success/:bookingId"
            element={
              <Layout>
                <BookingSuccess />
              </Layout>
            }
          />
          <Route
            path="/booking-failure"
            element={
              <Layout>
                <BookingFailure />
              </Layout>
            }
          />
          <Route
            path="/packets/:id"
            element={
              <Layout>
                <PacketDetails />
              </Layout>
            }
          />

          <Route
            path="/cars/:id"
            element={
              <Layout>
                <CarDetails />
              </Layout>
            }
          />

          <Route path="/admin" element={<AdminCalendar />} />
          <Route
            path="/partner"
            element={
              <Layout>
                <Partner />
              </Layout>
            }
          />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>

      <Footer />
    </div>
  );
}

export default App;
